export const schema = {
  id: 'central-heating-powerflush-certificate',
  name: 'Central Heating Powerflush & Water Treatment Certificate (BS 7593:2019)',
  description: 'Water treatment and chemical powerflushing compliance certificate to BS 7593',
  category: 'Plumbing',
  sections: [
    {
      id: 'contractorDetails',
      title: '1. Heating Contractor Details',
      fields: [
        { id: 'companyName', label: 'Company Name', type: 'text', required: true },
        { id: 'engineerName', label: 'Engineer Name', type: 'text', required: true },
        { id: 'telephone', label: 'Telephone Number', type: 'tel', required: true },
        { id: 'accreditationNumber', label: 'Gas Safe / OFTEC / CIPHE No.', type: 'text' }
      ]
    },
    {
      id: 'propertyDetails',
      title: '2. Client & Property Details',
      fields: [
        { id: 'clientName', label: 'Client / Homeowner Name', type: 'text', required: true },
        { id: 'propertyAddress', label: 'Property Address', type: 'textarea', required: true },
        { id: 'postCode', label: 'Postcode', type: 'text', required: true },
        { id: 'flushDate', label: 'Date of Powerflush', type: 'date', required: true }
      ]
    },
    {
      id: 'systemOverview',
      title: '3. Central Heating System Overview',
      fields: [
        { id: 'systemType', label: 'System Type', type: 'select', options: ['Open Vented (Feed & Expansion)', 'Sealed System (Combi/System Boiler)', 'Thermal Store / Heat Interface Unit', 'Heat Pump Low-Loss Header Circuit'], required: true },
        { id: 'boilerMakeModel', label: 'Boiler / Heat Source Make & Model', type: 'text', required: true },
        { id: 'radiatorCount', label: 'Total Number of Radiators / Emitters', type: 'number', required: true },
        { id: 'underfloorHeatingLoops', label: 'Underfloor Heating Loops Count', type: 'number' },
        { id: 'pipeworkMaterial', label: 'Pipework Material', type: 'select', options: ['Copper', 'Barrier Plastic (PEX/PB)', 'Microbore Copper (<15mm)', 'Iron / Mild Steel', 'Mixed Pipework'], required: true },
        { id: 'reasonForFlush', label: 'Reason for Powerflush', type: 'select', options: ['New Boiler Installation (BS 7593 Benchmark)', 'Cold Spots on Radiators (Magnetite Sludge)', 'Boiler Kettling / Heat Exchanger Noise', 'Circulator Pump Failure', 'Routine System Maintenance'], required: true }
      ]
    },
    {
      id: 'preFlushAssessment',
      title: '4. Pre-Flush Water Quality & System Condition',
      fields: [
        { id: 'preFlushWaterAppearance', label: 'Pre-Flush Water Appearance', type: 'select', options: ['Black / Heavy Magnetite Sludge', 'Brown / Severe Rust & Iron Oxide', 'Murky Grey / Microbial Contamination', 'Slightly Discoloured', 'Clear'], required: true },
        { id: 'preFlushTdsPpm', label: 'Pre-Flush Total Dissolved Solids (TDS ppm)', type: 'number' },
        { id: 'preFlushPh', label: 'Pre-Flush System Water pH', type: 'number' },
        { id: 'mainsWaterTdsPpm', label: 'Incoming Mains Water TDS (ppm Benchmark)', type: 'number', required: true },
        { id: 'radiatorColdSpotsCount', label: 'Radiators with Severe Cold Spots', type: 'number' }
      ]
    },
    {
      id: 'flushingProcess',
      title: '5. Powerflushing Process & Equipment',
      fields: [
        { id: 'flushingMachineModel', label: 'Powerflushing Machine / Pump Make & Model', type: 'text', required: true },
        { id: 'magneticFilterToolFitted', label: 'External Magnetic Filtration Unit Used during Flush?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'chemicalCleanerBrand', label: 'Chemical Cleaning Agent Used', type: 'text', required: true },
        { id: 'chemicalCleanerDosage', label: 'Cleaner Dosage Added (Litres)', type: 'number', required: true },
        { id: 'flowReversalExecuted', label: 'Reverse Flow Agitation Cycle Executed on Every Radiator?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'flushDurationHours', label: 'Flushing Cycle Duration (Hours)', type: 'number', required: true },
        { id: 'magneticSludgeRemovedGrams', label: 'Estimated Sludge / Magnetite Collected (grams)', type: 'number' }
      ]
    },
    {
      id: 'postFlushVerification',
      title: '6. Post-Flush Water Quality & Chemical Protection (BS 7593)',
      fields: [
        { id: 'postFlushWaterAppearance', label: 'Post-Flush Water Appearance', type: 'select', options: ['Crystal Clear', 'Slight Tint', 'Cloudy'], required: true },
        { id: 'postFlushTdsPpm', label: 'Final System Water TDS (ppm)', type: 'number', required: true },
        { id: 'tdsComparisonPct', label: 'TDS Difference vs Mains Water (%)', type: 'number' },
        { id: 'postFlushPh', label: 'Final System Water pH (Target 7.0 - 8.5)', type: 'number', required: true },
        { id: 'permanentMagneticFilterFitted', label: 'Permanent In-line Magnetic Filter Installed?', type: 'select', options: ['Yes', 'No', 'Already Present & Cleaned'], required: true },
        { id: 'permanentFilterMakeModel', label: 'Magnetic Filter Make & Model (e.g. Adey MagnaClean, Fernox TF1, SpiroTrap)', type: 'text' },
        { id: 'chemicalInhibitorBrand', label: 'BS 7593 Chemical Inhibitor Added', type: 'text', required: true },
        { id: 'chemicalInhibitorDosageLtrs', label: 'Inhibitor Dosage (Litres)', type: 'number', required: true },
        { id: 'inhibitorTestKitVerified', label: 'Inhibitor Concentration Verified by Test Kit / Digital Reader?', type: 'select', options: ['Yes - Verified Compliant', 'No'], required: true }
      ]
    },
    {
      id: 'declarations',
      title: '7. Engineer Declaration & Customer Handover',
      fields: [
        { id: 'engineerComments', label: 'Engineer Observations & Maintenance Advice', type: 'textarea' },
        { id: 'nextInhibitorCheckDue', label: 'Next Annual Inhibitor Level Check Due', type: 'date', required: true },
        { id: 'engineerSignature', label: 'Engineer Signature', type: 'signature', required: true },
        { id: 'customerSignature', label: 'Customer / Client Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
